import { useState } from 'react';

import EmiCalculator from './EmiCalculator';
export default function VemicalculatorPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="VemicalculatorPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <div> <EmiCalculator /></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
